import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import Spinner from 'react-bootstrap/Spinner';
import { Panel, PanelHeader, PanelBody } from '../../../components/panel/panel';
import { useAuth } from '../../../context/AuthContext.js';
import CustomAutoCompleteProductKey from '../../../components/formik/CustomAutoCompleteProductKey';
import { findMyProductKeyFavsDatatable } from '../../../services/CatalogService';
import { createProductKeyFav } from '../../../services/CatalogService';
import { deleteProductKeyFav } from '../../../services/CatalogService';
import { useNavigate } from "react-router-dom";

function ProductKey() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchValue, setSearchValue] = useState('');
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [sortField, setSortField] = useState('id'); // Campo de ordenamiento predeterminado
    const [sortDirection, setSortDirection] = useState('asc'); // Sentido de orden predeterminado
    const [selectedProductKey, setSelectedProductKey] = useState(null);
    const [autoCompleteKey, setAutoCompleteKey] = useState(0);
    const navigate = useNavigate();

    const fakeFormik = {
        values: {},
        touched: {},
        errors: {},
        setValues: () => { },
    };

    const fetchData = async (page = 1, search = '', sortField = 'id', sortDirection = 'asc') => {
        try {
            const response = await findMyProductKeyFavsDatatable({
                start: (page - 1) * rowsPerPage,
                length: rowsPerPage,
                search,
                sort: sortField,
                dir: sortDirection,
            });

            setData(response);
            setLoading(false);
        } catch (error) {
            console.error('Error al obtener datos:', error);
            setLoading(false);
        }
    };


    const handleAddProductKey = async () => {
        const selected = selectedProductKey;
        //console.log('selected', selected);

        if (!selected?.id) {
            return Swal.fire('Atención', 'Selecciona una clave válida', 'warning');
        }

        const confirm = await Swal.fire({
            title: '¿Estás seguro?',
            text: `¿Deseas asociar la clave "${selected.idKey}"?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, agregar',
            cancelButtonText: 'Cancelar',
        });

        if (confirm.isConfirmed) {
            try {
                await createProductKeyFav(selected.id);
                Swal.fire('Éxito', 'Clave asociada correctamente', 'success');
                fetchData(currentPage, searchValue, sortField, sortDirection); // Recarga tabla
                setSelectedProductKey(null);
            } catch (error) {
                console.error('Error al asociar clave:', error);
                const errorMessage = error?.response?.data?.message || 'Ocurrió un error al asociar la clave';
                Swal.fire('Error', errorMessage, 'error');
            }
        }
    };

    //Eliminar una clave de producto de la tabla
    const handleDeleteProductKey = async (id) => {
        const confirm = await Swal.fire({
            title: '¿Estás seguro?',
            text: 'Esta acción eliminará la clave de tus favoritos',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        });

        if (confirm.isConfirmed) {
            try {
                await deleteProductKeyFav(id);
                Swal.fire('Eliminado', 'La clave fue eliminada correctamente', 'success');
                fetchData(currentPage, searchValue, sortField, sortDirection); // Refresca la tabla
            } catch (error) {
                console.error('Error al eliminar:', error);
                const errorMessageEl = error?.response?.data?.message || 'No se pudo eliminar la clave';

                Swal.fire('Error', errorMessageEl, 'error');
            }
        }
    };


    useEffect(() => {
        setLoading(true);
        fetchData(currentPage, searchValue, sortField, sortDirection);
    }, [currentPage, rowsPerPage, sortField, sortDirection]);


    const columns = [
        {
            name: 'ID',
            selector: (row) => row.id,
            sortable: false,
            // sortField: 'id',
        },
        {
            name: 'Clave SAT',
            selector: (row) => row.productKey?.idKey || '',
            sortable: false,
            // sortField: 'productKey.idKey',
        },
        {
            name: 'Descripción',
            selector: (row) => row.productKey?.description || '',
            sortable: true,
            // sortField: 'productKey.description',
        },
        {
            name: 'Eliminar',
            button: true,
            cell: (row) => (
                <a href="#" onClick={(e) => {
                    e.preventDefault();
                    handleDeleteProductKey(row.id);
                }}>
                    <i className="fa fa-trash text-danger" />
                </a>
            ),
        }

    ];



    const customStyles = {
        headCells: {
            style: {
                color: '#202124',
                fontSize: '14px',
                backgroundColor: '#EEEEEE',
                border: 'none'
            },
        }
    };


    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: false,
        selectAllRowsItemText: 'Todos',
    };


    const progressComponent = "<i className='fa fa-trash'></i>";

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            setLoading(true);
            setCurrentPage(1);
            fetchData(currentPage, searchValue, sortField, sortDirection);
        }
    };

    return (
        <div>
            <div className="d-flex align-items-center mb-3">
                <div>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/">Inicio</Link></li>
                        <li className="breadcrumb-item">Facturación</li>
                        <li className="breadcrumb-item active">Claves de producto</li>
                    </ol>
                    <h1 className="page-header mb-0">Mis claves de producto</h1>
                </div>

            </div>



            <div className="row mb-3">
                <div className="col-xl-12">
                    <Panel>
                        <PanelHeader>Mis claves de producto</PanelHeader>
                        <PanelBody>

                            <div className="mb-5" style={{ paddingLeft: '14px' }}>
                                <CustomAutoCompleteProductKey
                                 key={autoCompleteKey}
                                    formik={{
                                        values: { productKey: selectedProductKey },
                                        setFieldValue: (field, value) => {
                                            if (field === 'productKey') {
                                                setSelectedProductKey(value);
                                            }
                                        },
                                        touched: {},
                                        errors: {},
                                    }}
                                    field="productKey"
                                />

                            </div>

                            <div className="d-flex justify-content-end gap-2 mt-3">


                                <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => navigate("/")}
                                >
                                Cancelar
                                </button>


                                <button className="btn btn-primary" onClick={handleAddProductKey}>
                                    Agregar
                                </button>
                            </div>


                            <hr className="my-4" style={{ borderTop: '3px solidrgb(129, 131, 134)' }} />

                            <DataTable
                                title=""
                                className="table"
                                columns={columns}
                                data={data.data}
                                progressPending={loading}
                                sortServer
                                pagination
                                paginationServer
                                paginationPerPage={rowsPerPage}
                                paginationTotalRows={data.recordsTotal} // Esto es solo un valor estimado
                                paginationDefaultPage={currentPage}
                                subHeader
                                customStyles={customStyles}
                                pointerOnHover
                                paginationComponentOptions={paginationComponentOptions}
                                noDataComponent="Sin información por mostrar"
                                progressComponent={
                                    <Spinner animation="border" insurance="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </Spinner>
                                }
                                subHeaderComponent={
                                    <div className='row'>
                                        <div className='col-sm-12 col-md-12'>
                                            <div className="input-group mb-3">
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Buscar..."
                                                    value={searchValue}
                                                    onChange={e => setSearchValue(e.target.value)}
                                                    onKeyPress={handleKeyPress}
                                                />
                                                <div className="input-group-text btn btn-info"
                                                    onClick={() => {
                                                        setLoading(true);
                                                        setCurrentPage(1);
                                                        fetchData(currentPage, searchValue, sortField, sortDirection); // Realizar búsqueda aquí
                                                    }}><i className="fa fa-search"></i></div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                onChangePage={(page) => {
                                    setCurrentPage(page);
                                }}
                                onSearch={(value) => {
                                    setSearchValue(value);
                                    setLoading(true);
                                    setCurrentPage(1); // Resetea la página al hacer una búsqueda
                                }}
                                onChangeRowsPerPage={(newPerPage, page) => {
                                    setRowsPerPage(newPerPage);
                                    setCurrentPage(1); // Resetea la página al cambiar la cantidad de registros por página
                                }}
                                onSort={(column, sortDirection) => {
                                    setSortDirection(sortDirection);
                                    setSortField(column.sortField);
                                    setLoading(true);
                                    setCurrentPage(1); // Resetea la página al hacer una búsqueda
                                }}
                            />
                        </PanelBody>
                    </Panel>
                </div>
            </div>
        </div>

    );
}

export default ProductKey;